import { render, staticRenderFns } from "./LandSuitabilityView.vue?vue&type=template&id=2de248e0"
import script from "./LandSuitabilityView.vue?vue&type=script&lang=js"
export * from "./LandSuitabilityView.vue?vue&type=script&lang=js"
import style0 from "./LandSuitabilityView.vue?vue&type=style&index=0&id=2de248e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports